var map = {
	"./00_post_trade_order.json": "JG85",
	"./01_get_commissionRate.json": "3Csz",
	"./01_get_leverage.json": "6Wqe",
	"./03_post_leverage.json": "HWdZ",
	"./04_post_allOpenOrders.json": "xM9z",
	"./05_post_closeAllPositions.json": "A11g",
	"./06_get_positions.json": "Uqg4",
	"./07_get_balance.json": "DyCG",
	"./08_get_forceOrders.json": "79Xw",
	"./09_get_allFillOrders.json": "KXGF",
	"./10_delete_trade_order.json": "Mwlf",
	"./11_get_all_openOrders.json": "Ui0Y",
	"./12_get_trade_order.json": "nj2w",
	"./14_get_trade_allOrders.json": "BW7b",
	"./15_get_margin_type.json": "Qb5x",
	"./16_post_margin_type.json": "dI3A",
	"./17_post_trade_positionMargin.json": "2WEb"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+eZJ";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/cswap/api/trade \.json$
// module id = +eZJ
// module chunks = 3